import React, { useState, useRef } from 'react';
import { UploadCloudIcon } from 'lucide-react';
export const UploadDropzone = ({
  onUploadComplete,
  images,
  maxFiles = 1,
  accept,
  label,
  helperText
}) => {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const acceptsCsv = typeof accept === 'string' && accept.indexOf('csv') !== -1;
  const resolvedAccept = accept || 'image/png,image/jpeg,image/gif';
  const resolvedLabel = label || (acceptsCsv ? 'Click to upload or drag and drop' : 'Upload images');
  const resolvedHelper = helperText || (acceptsCsv ? 'CSV file' + (maxFiles > 1 ? 's (up to ' + maxFiles + ')' : '') : 'PNG, JPG, GIF up to ' + maxFiles + ' files');
  const handleFiles = fileList => {
    if (!fileList || fileList.length === 0) return;
    if (acceptsCsv) {
      onUploadComplete(Array.from(fileList));
    } else {
      const mockUploadedImages = Array.from(fileList).map(file => URL.createObjectURL(file));
      onUploadComplete(mockUploadedImages);
    }
  };
  const openPicker = () => {
    if (inputRef.current) inputRef.current.click();
  };
  const onKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openPicker();
    }
  };
  return <div role="button" tabIndex={0} onClick={openPicker} onKeyDown={onKeyDown} onDragOver={e => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) setIsDragging(true);
  }} onDragEnter={e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }} onDragLeave={e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }} onDrop={e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    handleFiles(e.dataTransfer.files);
  }} className={'border-2 border-dashed rounded-md p-8 text-center cursor-pointer transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 ' + (isDragging ? 'border-indigo-500 bg-indigo-50' : 'border-gray-300 hover:border-indigo-400 hover:bg-gray-50')} data-id="element-3921" data-mp="255cia18l0a0x">
      <div className="space-y-2 pointer-events-none" data-id="element-3922" data-mp="17iv2ar5h9lhx">
        <div className="flex justify-center" data-id="element-3923" data-mp="12qlebgnxavia">
          {images && images.length > 0 ? <div className="flex flex-wrap gap-2" data-id="element-3924" data-mp="1hf83ea3cr1mp">
              {images.map((image, index) => <div key={index} className="h-16 w-16 bg-gray-200 rounded-md" data-id="element-3925" data-mp="1ch6c51vrvw05" data-mpi={index}></div>)}
            </div> : <UploadCloudIcon className={'h-10 w-10 ' + (isDragging ? 'text-indigo-500' : 'text-gray-400')} aria-hidden="true" data-id="element-3926" data-mp="1lhky83gk9f4p" />}
        </div>
        <div className="text-sm text-gray-700 font-medium" data-id="element-3927" data-mp="3n9znxopcjnvo">{resolvedLabel}</div>
        <p className="text-xs text-gray-500" data-id="element-3928" data-mp="22qdsf7wcbhr9">{resolvedHelper}</p>
      </div>
      <input ref={inputRef} type="file" accept={resolvedAccept} className="sr-only" multiple={maxFiles > 1} onChange={e => handleFiles(e.target.files)} data-id="element-3929" data-mp="27pgxutg8fpzr" />
    </div>;
};